import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  return isAuthenticated && user ? (
    <Outlet />
  ) : (
    <Navigate to="/user/login" replace />
  );
};

export default PrivateRoute;